import { Outlet, useLocation } from "react-router-dom";
import { getAllAdmins } from "../../../services/adminService";
import { DataTable } from "../../../Components/ui/data-table";
import { type ColumnDef } from "@tanstack/react-table";
import { LangContext, LangContextType } from "../../../utilities/customHooks";
import { useSuspenseQuery } from "@tanstack/react-query";
import ContentPageTopButtons from "../../../Components/ContentPageTopButtons";
import { DetailsContentHeader } from "./NewAdmin";
import textData from "../../../textData.json";
import { useContext } from "react";
import * as T from "../../../utilities/frontendTypes";

export const contentPageContainerStyle = "flex w-full justify-center h-full"

export const contentPageWrapperStyle = "relative flex flex-col h-full w-dashboardContentWidth max-w-maxDashboardContentWidth items-center text-text px-14";

function PartnerAdminList() {
  const { langState } = useContext(LangContext) as LangContextType
  const location = useLocation();

  const { data: allAdminsData } = useSuspenseQuery({
    queryKey: ["allAdmins", location.pathname],
    queryFn: () => getAllAdmins(),
  });

  const columns: ColumnDef<T.AdminHeader, unknown>[] = [
    {
      accessorKey: "adminName",
      header: textData.Pages.AdminPages.ProfilePages.PartnerAdminList.Col1[langState],
    },
    {
      accessorKey: "email",
      header: textData.Pages.AdminPages.ProfilePages.PartnerAdminList.Col2[langState],
    },
    {
      accessorKey: "userRegion",
      header: textData.Pages.AdminPages.ProfilePages.PartnerAdminList.Col3[langState],
    },
    {
      accessorKey: "dateCreated",
      header: textData.Pages.AdminPages.ProfilePages.PartnerAdminList.Col4[langState],
      cell: ({ getValue }) => {
        const val = getValue();
        if (!val) return "";
        return new Date(val as string | number).toLocaleDateString();
      },
    },
  ];

  const allAdminHeaders = allAdminsData.adminHeaders;

  return (
    <div className={contentPageContainerStyle}>
      <div className={contentPageWrapperStyle}>
        <ContentPageTopButtons />
        <DetailsContentHeader
          label={textData.Pages.AdminPages.ProfilePages.PartnerAdminList.PartnerAdminList[langState]}
          tooltip={textData.Pages.AdminPages.ProfilePages.PartnerAdminList.PartnerAdminListTooltip[langState]}
        />
        <DataTable
          columns={columns}
          data={allAdminHeaders}
          enableSorting
          enablePagination
        />
      </div>
      {/* New Admin Route */}
      <Outlet />
    </div>
  )
}

export default PartnerAdminList
